import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { IRiskOption } from "src/core/constants/options";
import {
  ListElement,
  ListElementWithRisk,
  useLegalTypesWithRiskListQuery,
} from "src/core/gql/graphql";
import { mapLegalTypesToRiskOptions } from "src/core/mappers/legal-type-risk.mapper";

const PERSON_CODE = "person";

/**
 * Type juridique avec risque
 */
export const useLegalTypeWithRiskOptions = (): {
  legalTypesWithRiskOptions: IRiskOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data: legalTypesWithRiskList, loading, error } = useLegalTypesWithRiskListQuery();

  const legalTypesWithRiskOptions: IRiskOption[] = useMemo(() => {
    if (!legalTypesWithRiskList?.listElements) return [];

    const legalTypes = legalTypesWithRiskList.listElements.filter(
      (element): element is ListElementWithRisk & ListElement =>
        "riskValues" in element && Array.isArray(element.riskValues) && element.code !== PERSON_CODE
    );

    const options = mapLegalTypesToRiskOptions(legalTypes);

    return options;
  }, [legalTypesWithRiskList]);

  return { legalTypesWithRiskOptions, loading, error };
};
